import { getCmpEventSalesRouteSearch } from "../../Invoicing/invoiceCardCheckoutRouting";

// Ticket Sales lists sponsorship attendees too (D:4616). Their "Update
// Attendee Details" action opens the Sponsorship Sales page, which owns the
// sponsorship attendee update, with the editor already open for that row.
const attendeeEditSourceParam = "editAttendeesSourceId";
const attendeeEditEventParam = "editAttendeesEventId";

export type EventSalesAttendeeEditTarget = Readonly<{
  eventId: string;
  sourceId: string;
}>;

export const getSponsorshipSalesSearch = ({
  editAttendees = false,
  eventId,
  invoiceNumber,
  sponsorshipId,
}: {
  editAttendees?: boolean;
  eventId: string;
  invoiceNumber?: string | null;
  sponsorshipId: string;
}): string => {
  const parameters = new URLSearchParams(
    getCmpEventSalesRouteSearch({
      destination: "sponsorshipSales",
      invoice: {
        eventId,
        eventSponsorshipRequestId: sponsorshipId,
        invoiceNumber,
      },
    }).replace(/^\?/, ""),
  );

  if (editAttendees && eventId.trim() && sponsorshipId.trim()) {
    parameters.set(attendeeEditEventParam, eventId.trim());
    parameters.set(attendeeEditSourceParam, sponsorshipId.trim());
  }

  const search = parameters.toString();
  return search ? `?${search}` : "";
};

export const getEventSalesAttendeeEditTarget = (
  search: string,
): EventSalesAttendeeEditTarget | null => {
  const parameters = new URLSearchParams(search);
  const eventId = parameters.get(attendeeEditEventParam)?.trim() || "";
  const sourceId = parameters.get(attendeeEditSourceParam)?.trim() || "";

  return eventId && sourceId ? { eventId, sourceId } : null;
};

/**
 * Manage Tickets with Update Attendee Details open for one registration
 * (Check-in Attendees "Update Attendee Details", IF11 EV15).
 */
export const getTicketSalesAttendeeEditSearch = ({
  eventId,
  registrationId,
}: {
  eventId: string;
  registrationId: string;
}): string => {
  const parameters = new URLSearchParams();
  if (eventId.trim() && registrationId.trim()) {
    parameters.set(attendeeEditEventParam, eventId.trim());
    parameters.set(attendeeEditSourceParam, registrationId.trim());
  }
  const search = parameters.toString();
  return search ? `?${search}` : "";
};
